import angular from 'angular';
import uiRouter from 'angular-ui-router';

import mysolvrEntryActionsMenuComponent from 'mysolvr-entry-actions-menu';
import mysolvrEntryDetailMenuComponent from 'mysolvr-entry-detail-menu';
import mysolvrEntryDetailComponent from './mysolvr-entry-detail.component';

let mysolvrEntryDetailModule = angular.module('mysolvrEntryDetail', [
  uiRouter,
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $stateProvider
      .state('engineer.mysolvr-entries.mysolvr-entry-detail', {
        url: '/:filter/:mysolvrEntryId',
        template: '<mysolvr-entry-detail mysolvr-entry="$resolve.mysolvrEntry" class="mysolvr-entry-detail"></mysolvr-entry-detail>',
        resolve: {
          mysolvrEntry: (MysolvrEntry, $stateParams, $state) => {
            return MysolvrEntry.get({mysolvrEntryId: $stateParams.mysolvrEntryId}).$promise
              .then(response => new MysolvrEntry(response.mysolvr_entry))
              .catch((reason) => {
                $state.go('engineer.mysolvr-entries.mysolvr-entry-list', {filter: 'solutions'});
              });
          },
        }
      });
  })
  .component('mysolvrEntryActionsMenu', mysolvrEntryActionsMenuComponent)
  .component('mysolvrEntryDetailMenu', mysolvrEntryDetailMenuComponent)
  .component('mysolvrEntryDetail', mysolvrEntryDetailComponent);

export default mysolvrEntryDetailModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/mysolvr-entries/screens/mysolvr-entry-detail/index.js